import React from "react";

export default function SingleTypeSelector(props) {
    const outDivs = props.types.map((typ, i) => {
       return <div 
                key={i} 
                onClick={() => props.setSelectableType(i)} 
                className={'font-bold p-2 mx-0 my-0.5 text-city-green-dark shadow-md cursor-pointer text-center hover:bg-city-green-dark hover:text-city-white ' + (props.selectableType === i ? 'bg-city-green-medium text-city-white' : '')}
              >{typ.label}</div>
    }); 
    return (
        <div className="flex flex-col items-center justify-center">
            <h3 className="font-bold md:text-lg self-start flex-col items-center justify-center pr-3  ml-1 mt-0">{props.selectorHeader}</h3>
            <div className="text-sm md:text-base flex flex-row">
                {outDivs}
            </div>
        </div>
    )
}